/************************************************************
 Assistive Product Namespace
 ************************************************************/

 window.assistiveProduct = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;


        // Cancel Requisition
        if (actionId == 3) {
            assistiveProduct.openReason(assistiveProduct.cancelReasonModalHandler);
        }
        else if(actionId == 23){

            var url = "/reports/download_report_pdf_v2?report_name=assistive_product&requisition_id="+(!action.task_id ? '' : action.task_id )+"&patient_id="+row.patient_id;

            Hades.showDocument(url);
            assistiveProduct._callback(true, assistiveProduct._action, assistiveProduct._row);
        }
        else {
            assistiveProduct.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        // Show alert for actions without undo
       // if(parseInt(assistiveProduct._action.wf_action_id) == 88 && !confirm(Hades.markAsReceivedWarning())) {
        //    assistiveProduct._callback(true, assistiveProduct._action, assistiveProduct._row);
         //   return;
       // }

        if (parseInt(assistiveProduct._action.wf_action_id) == 34 && !confirm(Hades.delegateWarning())){
            assistiveProduct._callback(true, assistiveProduct._action, assistiveProduct._row);
            return;
        }

        workflow.executeAction(assistiveProduct._action, assistiveProduct._callback, assistiveProduct._row);
    },
    // Open Reason
    openReason:function (callback) {
        var params = {
            task_id:assistiveProduct._action.task_id,
            wf_id:assistiveProduct._action.wf_id,
            wf_status_id:assistiveProduct._action.to_state_id,
            wf_action_id:assistiveProduct._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                assistiveProduct._callback(false, assistiveProduct._action, assistiveProduct._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:assistiveProduct._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:assistiveProduct._row.wf_id,
            wf_status_id:assistiveProduct._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/assistive_product/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    assistiveProduct._callback(false, assistiveProduct._action, assistiveProduct._row);
                } else {
                    assistiveProduct._callback(true, assistiveProduct._action, assistiveProduct._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                assistiveProduct._callback(false, assistiveProduct._action, assistiveProduct._row);
            });
    }

};